// Side-effect register the WS-3.A core card views with the global
// CardRegistry. Importing this barrel anywhere in the boot path (App.tsx)
// makes the registrations available to every consumer of `renderCard`.
//
// Mirrors the side-effect registration pattern used by `generative-ui/sdr/index.ts`.

import { registerCardComponent } from "@/components/generative-ui/envelope";
import {
  AgendaTimelineCardView,
  ChartCardView,
  ConfirmationCardView,
  InsightCardView,
  TableCardView,
  ToolCompletedCardView,
} from "./CoreCardViews";

registerCardComponent("table", TableCardView);
registerCardComponent("chart", ChartCardView);
registerCardComponent("agenda.timeline", AgendaTimelineCardView);
registerCardComponent("tool.completed", ToolCompletedCardView);
registerCardComponent("confirmation", ConfirmationCardView);
registerCardComponent("insight", InsightCardView);

export {
  TableCardView,
  ChartCardView,
  AgendaTimelineCardView,
  ToolCompletedCardView,
  ConfirmationCardView,
  InsightCardView,
};
